import { apiServer } from "../server/Setting";
import { WebClient } from "../server/WebClient";
import { 
    LeakCheckForm, 
    LeakCheckFormType, 
    CustomerInfoSection, 
    TankCheckSection, 
    PressureTestSection, 
    RegulatorCheckSection, 
    CustomSection, 
    deserializeLeakCheckForm,
    deserializeLeakCheckForms
} from "../../entities/business/LeakCheckFormTemplate";

// Request interfaces
export interface CreateLeakCheckFormRequest {
    name: string;
    type?: LeakCheckFormType;
    customerInfo?: CustomerInfoSection;
    tankCheck?: TankCheckSection;
    pressureTests?: PressureTestSection[];
    regulatorCheck?: RegulatorCheckSection;
    customSections?: CustomSection[];
}

export interface UpdateLeakCheckFormRequest {
    id: string;
    name?: string;
    isActive?: boolean;
    customerInfo?: CustomerInfoSection;
    tankCheck?: TankCheckSection;
    pressureTests?: PressureTestSection[];
    regulatorCheck?: RegulatorCheckSection;
    customSections?: CustomSection[];
}

// Service
export const LeakCheckService = {
    // Form management
    getAllForms: () => WebClient.Get(`${apiServer}/api/leak-check/forms`, deserializeLeakCheckForms),
    
    getForm: (id: string) => WebClient.GetOptional(`${apiServer}/api/leak-check/forms/${id}`, deserializeLeakCheckForm),
    
    createForm: (request: CreateLeakCheckFormRequest) => 
        WebClient.Post.Validated<LeakCheckForm>(`${apiServer}/api/leak-check/forms`, request, deserializeLeakCheckForm),
    
    updateForm: (request: UpdateLeakCheckFormRequest) => 
        WebClient.Put.Validated<LeakCheckForm>(`${apiServer}/api/leak-check/forms`, request, deserializeLeakCheckForm),
    
    deleteForm: (id: string) => 
        WebClient.Delete(`${apiServer}/api/leak-check/forms/${id}`)
};